import { render, staticRenderFns } from "./GoodsAmend.vue?vue&type=template&id=62fb37df&scoped=true&"
import script from "./GoodsAmend.vue?vue&type=script&lang=js&"
export * from "./GoodsAmend.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAmend.vue?vue&type=style&index=0&id=62fb37df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb37df",
  null
  
)

export default component.exports